module.exports = "<div class=\"text-center\">\n    <img src=\"assets/img/error/no_data.png\" style=\"width: 150px\">\n    <h2>対象のデータがありません。</h2>\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/no_data_component/noData.component.html
// module id = ./src/app/component/shared/no_data_component/noData.component.html
// module chunks = main